import { NavMenu } from "./NavMenu"

export function Header() {
  return (
    <header className="border-b">
     
        <NavMenu />
    </header>
  )
} 